module.exports = __webpack_public_path__ + "img/Rectangle 928.97d7b218.svg";